var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6878 19.9999H0V0H13.6878C18.3865 0 22.1938 3.80832 22.1938 8.50552V11.4916C22.1938 16.1916 18.3865 19.9999 13.6878 19.9999Z",
    fill: "#AEDB01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2146 29.9999H0V20C0 14.4778 4.47652 10 9.99997 10H17.2146C22.7381 10 27.2146 14.4778 27.2146 20C27.2146 25.5222 22.7381 29.9999 17.2146 29.9999Z",
    fill: "#B0B1AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1938 11.3278V11.4944C22.1938 16.1944 18.3865 20 13.685 20H0C0 17.2389 1.12191 14.7389 2.92696 12.9278C4.73756 11.1167 7.23686 10 10.0027 10H17.2146C19.028 10.0028 20.7275 10.4861 22.1938 11.3278Z",
    fill: "#5D6D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoba);
export default __webpack_public_path__ + "static/media/boba.052e1b0ef9c4b9b273104dcc411a999d.svg";
export { ForwardRef as ReactComponent };